import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';
import { writeCookie, getQueryString } from '@/tools/tools';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    _classCallCheck(this, default_1);
    return _callSuper(this, default_1, arguments);
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getAppLoginInfor();
    }
    // 获取app登录信息并存起来
  }, {
    key: "getAppLoginInfor",
    value: function () {
      var _getAppLoginInfor = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var anchorobj;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!getQueryString('equipMeid')) {
                _context.next = 7;
                break;
              }
              anchorobj = {
                accessToken: getQueryString('token'),
                equip: getQueryString('equip'),
                equipMeid: getQueryString('equipMeid'),
                equipVersion: getQueryString('equipVersion'),
                model: getQueryString('model'),
                version: getQueryString('version'),
                macCode: getQueryString('macCode'),
                src: getQueryString('src'),
                languageType: getQueryString('language')
              };
              if (!getQueryString('token')) {
                _context.next = 6;
                break;
              }
              writeCookie('accessToken', getQueryString('token'));
              _context.next = 6;
              return this.setUserInfoList();
            case 6:
              writeCookie('anchor', anchorobj);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAppLoginInfor() {
        return _getAppLoginInfor.apply(this, arguments);
      }
      return getAppLoginInfor;
    }()
  }]);
}(Vue);
__decorate([Action('user/setUserInfoList')], default_1.prototype, "setUserInfoList", void 0);
default_1 = __decorate([Component({
  components: {}
})], default_1);
export default default_1;